export default {
    db: null,
    isCordova: (window.cordova !== undefined && window.cordova !== null),
    init() {
        if(window.sqlitePlugin || window.indexedDB){
            this.openDatabase();
            this.setupSchema();
        }
    },
    openDatabase() {
        if(this.isCordova) {
            this.db = window.sqlitePlugin.openDatabase({
                name: 'sqlite.db',
                location: 'default',
                androidDatabaseProvider: 'system'
            });
        }
    },
    setupSchema() {
        if(this.isCordova) {
            this.db.transaction(function (tx) {
                tx.executeSql('create table if not exists offline_data (action text, json text)');   //離線狀態下，Data存取資料表
                tx.executeSql('create table if not exists gift_read (id INTEGER NOT NULL PRIMARY KEY, type text, gift_id INTEGER)');   // 禮物盒已讀未讀
                tx.executeSql('create table if not exists shopping_cart_meal_data (id INTEGER NOT NULL PRIMARY KEY, meal_id INTEGER, data_json text)');   // 購物車餐點資料
                tx.executeSql('create table if not exists shopping_cart_meal_choiceList (id INTEGER NOT NULL PRIMARY KEY, meal_id INTEGER, choicePrice INTEGER, stroe_id INTEGER,text_note VARCHAR, amount INTEGER, combination_json text)');   // 購物車選擇組合
                tx.executeSql('create table if not exists order_record_meal_data (id INTEGER NOT NULL PRIMARY KEY,orderId INTEGER,orderSn VARCHAR,takeoutId INTEGER, meal_id INTEGER, data_json text)');   // 訂單記錄餐點資料
                tx.executeSql('create table if not exists order_record_meal_choiceList (id INTEGER NOT NULL PRIMARY KEY,orderId INTEGER,orderSn VARCHAR,takeoutId INTEGER, meal_id INTEGER, choicePrice INTEGER, stroe_id INTEGER,text_note VARCHAR, amount INTEGER, combination_json text)');   // 訂單記錄選擇組合
                tx.executeSql('create table if not exists order_record_snapshot_data (id INTEGER NOT NULL PRIMARY KEY,orderId INTEGER,orderSn VARCHAR,takeoutId INTEGER, data_json text)');   // 訂單記錄全部資料
                tx.executeSql('create table if not exists alert_message (id INT, read_at DATETIME, alert_type INT, closed_at DATETIME)');   // 彈窗紀錄
            }, function (error) { // error;
                // eslint-disable-next-line no-console
                console.log('Create Transaction ERROR: ' + error.message);
            }, function () {
                // eslint-disable-next-line no-console
                console.log('Populated database OK');
            });
        } else {
            let self = this;
            let request =  window.indexedDB.open("sqlite.db", 1);

            request.onerror = function (event) {
                // eslint-disable-next-line no-console
                console.log('Create Transaction ERROR');
            }

            request.onsuccess = function (event) {
                // eslint-disable-next-line no-console
                console.log('Populated database OK');
                self.db = request.result;
            };

            request.onupgradeneeded = function(event) {
                let db = event.target.result;

                if (db.objectStoreNames.contains('shopping_cart_meal_data')) {
                    db.deleteObjectStore('shopping_cart_meal_data')
                }

                let shoppingCartMealData = db.createObjectStore('shopping_cart_meal_data', {keyPath: 'id', autoIncrement: true});
                shoppingCartMealData.createIndex('meal_id', 'meal_id', { unique: false });
                shoppingCartMealData.createIndex('data_json', 'data_json', { unique: false });

                if (db.objectStoreNames.contains('shopping_cart_meal_choiceList')) {
                    db.deleteObjectStore('shopping_cart_meal_choiceList')
                }

                let shoppingCartMealChoiceList = db.createObjectStore('shopping_cart_meal_choiceList', {keyPath: 'id', autoIncrement: true});
                shoppingCartMealChoiceList.createIndex('meal_id', 'meal_id', { unique: false });
                shoppingCartMealChoiceList.createIndex('choicePrice', 'choicePrice', { unique: false });
                shoppingCartMealChoiceList.createIndex('stroe_id', 'stroe_id', { unique: false });
                shoppingCartMealChoiceList.createIndex('text_note', 'text_note', { unique: false });
                shoppingCartMealChoiceList.createIndex('amount', 'amount', { unique: false });
                shoppingCartMealChoiceList.createIndex('combination_json', 'combination_json', { unique: false });
            }
        }
    },
    executeSql(sql, paramArray, callback){
        if(!window.sqlitePlugin) return;

        this.db.transaction(function(tx) {
            // eslint-disable-next-line no-console
            console.log(sql);
            // eslint-disable-next-line no-console
            console.log(paramArray);
            tx.executeSql(sql, paramArray);
        }, function(error) { // error;
            // eslint-disable-next-line no-console
            console.log('Transaction ERROR: ' + error.message);
            callback(false);
        }, function() {
            // eslint-disable-next-line no-console
            console.log('Populated database OK');
            callback(true);
        });
    },
    transaction(sqlArray, paramArray){
        if(!window.sqlitePlugin) return;

        this.db.transaction(function(tx) {
            sqlArray.forEach((sql, index) => {
                tx.executeSql(sql, paramArray[index]);
            });
        }, function(error) { // error;
            // eslint-disable-next-line no-console
            console.log('Transaction ERROR: ' + error.message);
        }, function() {
            // eslint-disable-next-line no-console
            console.log('Populated database OK');
        });
    },
    update(sql, paramArray, callback) {
        this.executeSql(sql, paramArray, callback);
    },
    insert(sql, paramArray, callback) {
        this.executeSql(sql, paramArray, callback);
    },
    delete(sql, paramArray, callback) {
        this.executeSql(sql, paramArray, callback);
    },
    query(sql, paramArray, funcResult) {
        if(!window.sqlitePlugin) return;

        this.db.readTransaction(function(tx) {
            tx.executeSql(sql, paramArray, function(tx, resultSet) {
                // eslint-disable-next-line no-console
                console.log(sql);
                // eslint-disable-next-line no-console
                console.log(paramArray);
                //  讀取資料的方法，var obj1 = resultSet.rows.item(0).json
                funcResult(resultSet);
            }, function(tx, error) { // tx, error;
                // eslint-disable-next-line no-console
                console.log('SELECT error: ' + error.message);
            });
        }, function(error) { // error;
            // eslint-disable-next-line no-console
            console.log('sql: ' + sql);
            // eslint-disable-next-line no-console
            console.log(paramArray);
            // eslint-disable-next-line no-console
            console.log('query transaction error: ' + error.message);
        }, function() {
            // eslint-disable-next-line no-console
            console.log('query transaction ok');
        });
    },
    updateDB(table, dataList, callback) {
        let self = this;
        let updateList = [];
        let transaction = self.db.transaction([table], "readwrite");
        let objectStore = transaction.objectStore(table);
        for(let i = 0; i < dataList.length; i++) {
            let request = objectStore.put(dataList[i]);
            request.onsuccess = function(event) {
                let item = dataList[i];
                item.db_key_id = event.target.result;
                updateList.push(item);
                if(dataList.length === updateList.length) {
                    callback(updateList);
                }
            };
        }
    },
    insertDB(table, dataList, callback) {
        let self = this;
        let insertList = [];
        let transaction = self.db.transaction([table], "readwrite");
        let objectStore = transaction.objectStore(table);
        for(let i = 0; i < dataList.length; i++) {
            let request = objectStore.add(dataList[i]);
            request.onsuccess = function(event) {
                let item = dataList[i];
                item.db_key_id = event.target.result;
                insertList.push(item);
                if(dataList.length === insertList.length) {
                    callback(insertList);
                }
            };
        }
    },
    deleteDB(table, field, value, callback) {
        let self = this;
        let deleteList = [];
        let transaction = self.db.transaction([table], "readwrite");
        let objectStore = transaction.objectStore(table);
        if(field !== "" && value !== "") {
            let index = objectStore.index(field);

            index.openCursor(value).onsuccess = function(event) {
                let cursor = event.target.result;
                if (cursor) {
                    objectStore.delete(cursor.value.id);
                    deleteList.push(cursor.value);
                    cursor.continue();
                } else {
                    callback(deleteList);
                }
            };
        } else if(field === "" && value !== "") {
            let request = objectStore.delete(value);
            request.onsuccess= function(event) {
                deleteList.push(event.target.result);
                callback(deleteList);
            };
        } else {
            objectStore.openCursor().onsuccess = function(event) {
                let cursor = event.target.result;
                if (cursor) {
                    objectStore.delete(cursor.value.id);
                    deleteList.push(cursor.value);
                    cursor.continue();
                } else {
                    callback(deleteList);
                }
            };
        }
    },
    queryDB(table, field, value, callback) {
        let self = this;
        let resultList = [];
        let transaction = self.db.transaction([table]);
        let objectStore = transaction.objectStore(table);
        if(field !== "" && value !== "") {
           let index = objectStore.index(field);

           index.openCursor(value).onsuccess = function(event) {
               let cursor = event.target.result;
               if (cursor) {
                   resultList.push(cursor.value);
                   cursor.continue();
               } else {
                   callback(resultList);
               }
           };

       } else if(field === "" && value !== "") {
           let request = objectStore.get(value);
           request.onsuccess= function(event) {
               resultList.push(event.target.result);
               callback(resultList);
           };
       } else {
           objectStore.openCursor().onsuccess = function(event) {
               let cursor = event.target.result;
               if (cursor) {
                   resultList.push(cursor.value);
                   cursor.continue();
               } else {
                   callback(resultList);
               }
           };
       }
    },
}